import { apiConfig } from '../config';
import { request, waitUntilStatusCompleted, withErrorHandling, withRetry } from './SetDirection';

export async function setGa2LastSu(deviceId, suId, options = {}, activeStatuses = ['Pending', 'Running']) {
  const checkStatus = await callSetGa2LastSu(deviceId, suId, options);

  return waitUntilStatusCompleted(checkStatus, options, activeStatuses);
}

export function callSetGa2LastSu(deviceId, suId, options = {}) {
  const url = apiConfig.cmServiceSetLastSu(deviceId);
  const body = JSON.stringify({ 'su-id': suId });

  return withErrorHandling(withRetry(request, options.retry))(url, {
    method: 'POST',
    body
  });
}
